<template>
  <tr class="mds-data-table__row client-row">
    <td class="mds-data-table__cell">
      <div v-if="isPending" class="pending-icon mds-icon">
        <svg class="mds-icon" aria-hidden="true">
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="static/mds/icons/mds.svg#clock-back"
          ></use>
        </svg>
      </div>
    </td>
    <td class="mds-data-table__cell" scope="row">
      <slot></slot>
    </td>
    <td class="mds-data-table__cell">
      {{ category }}
    </td>
    <td class="mds-data-table__cell"></td>
    <td class="mds-data-table__cell" v-if="isAllClientChangeStatus">
      <div class="mds-form__select" v-if="showCategory">
        <select
          class="mds-form__select-input clients-list-select-categories"
          :value="newCategory"
          @change="onSelectCategory"
        >
          <option value="Category">
            Category
          </option>
          <option
            v-for="categoryData in categoriesData"
            class="mds-form__select-option"
            :value="categoryData.category"
            :key="categoryData.categoryID"
          >
            {{ categoryData.category }}
          </option>
        </select>
        <div class="mds-form__select-visual-wrap"></div>
        <span class="mds-form__select-open-indicator">
          <svg class="mds-icon mds-form__select-open-icon" aria-hidden="true">
            <use xlink:href="static/mds/icons/mds.svg#caret-down--s"></use>
          </svg>
        </span>
      </div>
    </td>
    <td class="mds-data-table__cell">
      <status-icons :status="[{ name: status }]" />
      {{ status }}
    </td>
    <td class="mds-data-table__cell">
      <template v-if="isAllClientChangeStatus">
        <status-icons v-if="newStatus" :status="[{ name: newStatusIcon }]" />
        <div v-else class="status-icons"></div>
        <div class="mds-form__select change-status-select-clients-list">
          <select
            class="mds-form__select-input change-status__select--clients-list"
            id="change-status__select--clients-list"
            :value="newStatus"
            @change="onSelect"
          >
            <option
              v-for="option in options"
              class="mds-form__select-option"
              :value="option.value"
              :disabled="option.config.disabled"
              :key="option.value"
            >
              {{ option.label }}
            </option>
          </select>
          <div class="mds-form__select-visual-wrap"></div>
          <span class="mds-form__select-open-indicator">
            <svg class="mds-icon mds-form__select-open-icon" aria-hidden="true">
              <use xlink:href="static/mds/icons/mds.svg#caret-down--s"></use>
            </svg>
          </span>
        </div>
      </template>
      <template v-else-if="newStatus">
        <status-icons :status="[{ name: newStatusIcon }]" />
        {{ newStatusText }}
      </template>
    </td>
  </tr>
</template>
<script>
import StatusIcons from '@/components/atoms/StatusIcons';

export default {
  name: 'change-status-clients-list',
  components: {
    StatusIcons,
  },
  props: {
    category: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    newStatus: {
      type: Number,
      default: 0,
    },
    newStatusIcon: {
      type: String,
      default: '',
    },
    newStatusText: {
      type: String,
      default: '',
    },
    isPending: {
      type: Boolean,
      default: false,
    },
    isAllClientChangeStatus: {
      type: Boolean,
      default: false,
    },
    categoriesData: {
      type: Array,
      default() {
        return [];
      },
    },
    newCategory: {
      type: String,
      default: 'Category',
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showCategory: false,
    };
  },
  created() {
    this.showCategory = this.checkToShowClientCategory;
  },
  methods: {
    onSelect(event) {
      this.$emit('onSelect', parseInt(event.target.value, 10));
    },
    onSelectCategory(event) {
      this.$emit('onSelectCategory', parseInt(event.target.value, 10));
    },
  },
  computed: {
    checkToShowClientCategory() {
      const statusesToHideCategory = ['Approved', 'OnWatch'];
      if (!statusesToHideCategory.includes(this.status)) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss">
.client-row {
  background-color: $mds-color-neutral-95;
  border-bottom: 1px solid $mds-color-neutral-90;

  & td {
    padding-bottom: $mds-space-2-x;
    padding-top: $mds-space-2-x;
    .change-status-select-clients-list {
      width: 70%;
    }
  }
  & td:first-child {
    padding-left: $mds-space-inset-half-x;
  }
  & div[class^="status-array"] {
    display: inline;
  }
  & .status-icons {
    margin-right: $mds-space-half-x;
  }
}
</style>
